import { render } from "./PipGalFilter.vue?vue&type=template&id=77cb560c&scoped=true"
import script from "./PipGalFilter.vue?vue&type=script&lang=js"
export * from "./PipGalFilter.vue?vue&type=script&lang=js"

import "./PipGalFilter.vue?vue&type=style&index=0&id=77cb560c&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cb560c"]])

export default __exports__